module.exports = __webpack_public_path__ + "img/brand-logo-single-color.0ecd493b.svg";